import {
  createContext,
  useContext,
  useEffect,
  useState,
  cloneElement,
  isValidElement,
  Children,
  useCallback,
} from 'react';
import liff from '@line/liff';
import { useCookies } from 'react-cookie';
import { useRecoilState } from 'recoil';
import { useLocation, useNavigate } from 'react-router-dom';
import { userState, maintenenceGlobalState } from '../state';
import {
  getAccountMapping,
  getWhiteListLineUIDAccess,
} from '../services/pcbff';
import { config } from '../config';
import Loading from '../components/loading';
import { trackEvent, trackUser } from '../utils/analytics';

// Provide an explicit (possibly empty) default object to clarify shape
const AuthContext = createContext({});

const AuthProvider = ({ liffId, children, allowGuest }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const [user, setUser] = useRecoilState(userState);
  const [maintenenceGlobal] = useRecoilState(maintenenceGlobalState);
  const [cookie] = useCookies([config.sysCookieName]);
  const [loading, setLoading] = useState(true);
  // const [token, setToken] = useState(localStorage.getItem('site') || '');

  useEffect(() => {
    const initialize = async () => {
      console.log(user);
      // Already login
      if ((user.username && user.system) || allowGuest) {
        setLoading(false);
      } else if (liff.isInClient() && liffId) {
        try {
          await liff.init({
            liffId,
            withLoginOnExternalBrowser: true,
          });

          const profile = await liff.getProfile();
          await authByLine(profile.userId);
        } catch (error) {
          navigate(`/not-found`);
        }
      }
      // For test direct by pass LINE UUID
      else if (params.get('id')) {
        const allowLineUIDList = await getWhiteListLineUIDAccess();
        if (allowLineUIDList.includes(params.get('id'))) {
          authByLine(params.get('id'));
        }
      } else if (cookie.nekohtuAresU) {
        if (cookie.nekohtuAresU.substring(0, 3) === 'V2:') {
          authByPSSSO2();
        } else {
          authByPSSSO();
        }
      }
    };

    if (!maintenenceGlobal?.isMaintenance) {
      initialize();
    }
  }, []);

  const authByPSSSO = async () => {
    const system = 'pruservices';
    const response = await getAccountMapping({
      userAuthToken: cookie.nekohtuAresU,
      system,
    });
    if (response.status === 'OK') {
      trackUser(response.data);

      setUser({
        ...response.data,
        system,
      });
      setLoading(false);
    } else {
      trackEvent(
        'PRUServices Rich menu - ไม่อยู่ในระบบ',
        'PRUServices Rich menu - ไม่อยู่ในระบบ',
      );
      return (window.location.href = `${config.pruservices.homeURL}`);
    }
  };

  const authByPSSSO2 = async () => {
    const system = 'pruservicesV2';
    console.log('cookie', cookie.nekohtuAresU.substring(3));
    const response = await getAccountMapping({
      userAuthToken: cookie.nekohtuAresU.substring(3),
      system,
    });
    if (response.status === 'OK') {
      trackUser(response.data);

      setUser({
        ...response.data,
        system,
      });
      setLoading(false);
    } else {
      trackEvent(
        'PRUServices Rich menu - ไม่อยู่ในระบบ',
        'PRUServices Rich menu - ไม่อยู่ในระบบ',
      );
      // return (window.location.href = `${config.pruservicesV2.homeURL}`);
    }
  };

  const authByLine = async token => {
    const system = 'line';
    const response = await getAccountMapping({ token, system });
    console.log('response', response);
    if (response.status === 'OK') {
      // trackUser(resultUser.data);
      // trackPageView(source);
      setUser({
        ...response.data,
        system: system,
      });
    } else {
      trackEvent(
        'PRUServices Rich menu - ไม่อยู่ในระบบ',
        'PRUServices Rich menu - ไม่อยู่ในระบบ',
      );
      const liffUrl = `https://liff.line.me/${liffId}`;
      const callbackUrl = encodeURI(`${liffUrl}${location.search}`);
      return (window.location.href = `${config.pruid_login}&c=${callbackUrl}`);
    }
    setLoading(false);
  };

  const renderChildren = useCallback(() => {
    if (loading) return <Loading />;

    return Children.map(children, child => {
      if (isValidElement(child)) {
        return cloneElement(child, {});
      }
      return child;
    });
  }, [children, loading]);

  return (
    <AuthContext.Provider value={{}}>{renderChildren()}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
